export const registerEs = {
  registerPage: {
    joinTitle: "Únete a Sentinel Crop",
    joinSubtitle: "Crea tu cuenta para monitorizar cultivos, campos de golf y espacios verdes con tecnología satelital",
    stepOf: "Paso {{step}} de 2",
    firstName: "Nombre",
    firstNamePlaceholder: "Nombre",
    lastName: "Apellido",
    lastNamePlaceholder: "Apellido",
    email: "Email",
    emailPlaceholder: "Introduce tu email",
    password: "Contraseña",
    passwordPlaceholder: "Crea una contraseña",
    confirmPassword: "Confirmar Contraseña",
    confirmPasswordPlaceholder: "Confirma tu contraseña",
    userType: "Tipo de Usuario",
    farmer: "Agricultor",
    cooperative: "Cooperativa",
    insuranceCompany: "Compañía de Seguros",
    urbanManager: "Gestor de Espacios Verdes Urbanos",
    farmName: "Nombre de la finca",
    companyName: "Nombre de la empresa",
    farmNamePlaceholder: "Nombre de tu finca",
    companyNamePlaceholder: "Nombre de tu empresa",
    hectares: "Hectáreas",
    hectaresPlaceholder: "ej. 50",
    cropType: "Tipo de cultivo",
    selectCropType: "Seleccionar tipo de cultivo",
    oliveGrove: "Olivar",
    vineyard: "Viñedo",
    wheat: "Trigo",
    corn: "Maíz",
    sunflower: "Girasol",
    canola: "Colza",
    almondTrees: "Almendros",
    citrus: "Cítricos",
    other: "Otro",
    organizationType: "Tipo de Organización",
    selectOrgType: "Seleccionar tipo de organización",
    municipal: "Municipal / Ayuntamiento",
    maintenanceCompany: "Empresa de Mantenimiento",
    environmentalNGO: "ONG Medioambiental",
    environmentalConsulting: "Consultoría Medioambiental",
    managedGreenSpaces: "Número de Espacios Verdes Gestionados",
    managedGreenSpacesPlaceholder: "ej. 15 parques",
    managedGreenSpacesHint: "Parques, jardines, zonas arboladas, etc.",
    country: "País",
    selectCountry: "Seleccionar país",
    phone: "Teléfono",
    phonePlaceholder: "+34 600 000 000",
    agreeTerms: "Acepto los",
    termsOfService: "Términos de Servicio",
    and: "y la",
    privacyPolicy: "Política de Privacidad",
    back: "Atrás",
    continue: "Continuar",
    createAccount: "Crear Cuenta",
    validating: "Validando...",
    creatingAccount: "Creando cuenta...",
    orSignUpWith: "O regístrate con",
    continueWithGoogle: "Continuar con Google",
    alreadyHaveAccount: "¿Ya tienes cuenta?",
    signIn: "Iniciar sesión",
    errorAllFields: "Por favor completa todos los campos",
    errorPasswordMatch: "Las contraseñas no coinciden",
    errorRequiredFields: "Por favor completa todos los campos obligatorios",
    errorFarmerFields: "Los agricultores deben especificar hectáreas y tipo de cultivo",
    errorCoopFields: "Las cooperativas deben especificar hectáreas y tipo de cultivo",
    errorUrbanFields: "Los gestores urbanos deben especificar tipo de organización y número de áreas gestionadas",
    errorAccountExists: "Este email ya está registrado. Por favor inicia sesión.",
    accountExistsTitle: "Cuenta existente",
    registrationError: "Error de Registro",
    registrationSuccess: "Registro Exitoso",
    registrationSuccessDesc: "Por favor revisa tu email para confirmar tu cuenta, luego podrás iniciar sesión.",
    unexpectedError: "Ocurrió un error inesperado",
    googleSignUpError: "Error de Registro con Google"
  }
};